
    import { Component, PropSync, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Anmeldung from '@/types/Anmeldung';
    import { DetailConfig, DetailParams } from '@/types';
    import { AclModul, AclPermission } from '@/store/types';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('terminkalender', ['filterAnmeldung', 'anmeldungen', 'loaders', 'anmeldungDialog']),
            ...mapGetters('authentication', ['getSystemEinstellung', 'isAllowed']),
        },
        methods: {
            ...mapActions('terminkalender', [
                'loadTerminanmeldungen',
                'syncAnmeldungen',
                'updateAnmeldung',
            ]),
            ...mapActions('patient', [
                'loadPatient',
                'patientDetail',
            ]),
            ...mapMutations('terminkalender', ['setAnmeldungDetail']),
        },
    })
    export default class AnmeldungenDetail extends Vue {
        @PropSync('anmeldung') public anmeldungSync!: Anmeldung;
        @PropSync('detail') public detailSync!: boolean;

        public loadPatient!: (payload: { patnr: number }) => Promise<void>;
        public patientDetail!: (visible: boolean) => void;
        public isAllowed!: (moduleName: AclModul, permission: AclPermission | AclPermission[]) => boolean;

        public get detailConfig(): DetailConfig<Anmeldung> {
            return {
                remote: '/terminkalender/anmeldung',
                title: 'Anmeldung',
                class: Anmeldung,
                buttons: {
                    delete: {
                        visible: this.isAllowed('system', 'index'),
                    },
                },
                actions: {
                    patientanlegen: {
                        action: '/terminkalender/anmeldung/patientanlegen',
                        confirm: {
                            title: 'Patient anlegen',
                            text: 'Patient wird neu angelegt. Sind Sie sicher?',
                            yes: 'Ja',
                            no: 'Nein',
                        },
                        success: 'Patient wurde angelegt',
                    },
                },
            };
        }

        public get detailParams(): DetailParams<Anmeldung> {
            return {
                anmeldung_id: this.anmeldungSync.anmeldung_id,
            };
        }

        public onActionPatientAnlegen(anmeldung: Anmeldung, isSuccess: boolean): void {
            if (isSuccess && anmeldung.patient?.patnr) {
                this.$router.push('/');

                this.loadPatient({ patnr: anmeldung.patient.patnr as number })
                    .then(() => this.$nextTick(() => this.patientDetail(true)));
            }
        }
    }
